import { ELLA_MIC_CONSENT_COPY } from '../utils/ellaMicConsent';

const GOLD = '#C9A84C';

export default function EllaMicConsentDialog({ onAllow, onNotNow }) {
  return (
    <div
      style={{
        position: 'fixed',
        inset: 0,
        zIndex: 100000,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        background: 'rgba(0,0,0,0.7)',
        backdropFilter: 'blur(8px)',
      }}
    >
      <div
        style={{
          background: '#1a1a1a',
          borderRadius: 16,
          padding: '28px 32px',
          maxWidth: 420,
          width: '90%',
          border: `1px solid ${GOLD}33`,
          boxShadow: '0 8px 32px rgba(0,0,0,0.5)',
        }}
      >
        <p style={{ color: '#fff', fontSize: 15, lineHeight: 1.55, textAlign: 'center', margin: '0 0 22px' }}>
          {ELLA_MIC_CONSENT_COPY}
        </p>
        <div style={{ display: 'flex', gap: 12, justifyContent: 'center' }}>
          <button
            type="button"
            onClick={onAllow}
            style={{
              background: GOLD,
              color: '#000',
              border: 'none',
              borderRadius: 8,
              padding: '10px 20px',
              fontSize: 14,
              fontWeight: 600,
              cursor: 'pointer',
            }}
          >
            Allow
          </button>
          <button
            type="button"
            onClick={onNotNow}
            style={{
              background: 'transparent',
              color: GOLD,
              border: `1px solid ${GOLD}`,
              borderRadius: 8,
              padding: '10px 20px',
              fontSize: 14,
              fontWeight: 600,
              cursor: 'pointer',
            }}
          >
            Not now
          </button>
        </div>
      </div>
    </div>
  );
}
